import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './BackButton.css';

/**
 * BackButton - A premium, standardized "Return to Base" button.
 * Matches the tactical cyberpunk aesthetic of the platform.
 * 
 * @param {string} to - Optional internal route to navigate to. Defaults to home ('/').
 * @param {function} onClick - Optional click handler (overrides 'to').
 * @param {string} label - Button text. Defaults to "RETURN TO BASE".
 */
const BackButton = ({ to = '/', onClick, label = 'RETURN TO BASE' }) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
      return;
    }
    navigate(to);
  };

  // If used as a simple link, we use Link, otherwise a button for custom handlers
  if (!onClick && to) {
    return (
      <Link to={to} className="standard-back-button">
        {label}
      </Link>
    );
  }

  return (
    <button type="button" onClick={handleClick} className="standard-back-button">
      {label}
    </button>
  );
};

export default BackButton;
